<script setup lang="ts">
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'

    const props = defineProps<{
        ActivePage: string
        workspaceId: number
        tchProjectId: number
        projectId: string
        planId: string | null
    }>()

    const route = useRoute()

    function nav(name: string)
    {
        return {
            name,
            params: {
                workspaceId: props.workspaceId,
                tchProjectId: props.tchProjectId,
                projectId: props.projectId,
                planId: props.planId ?? undefined
            },
            query: route.query
        }
    }

    const pages = computed(() => [
        {
            key: 'settings',
            label: 'Settings',
            route: 'q-project-settings-path'
        },
        //{
        //    key: 'summary',
        //    label: 'Summary',
        //    route: 'q-project-summary-path'
        //},
        //{
        //    key: 'phases',
        //    label: 'Phases',
        //    route: 'q-project-phases-path'
        //},
        {
            key: 'revenues',
            label: 'Revenues',
            route: 'q-project-revenues-path'
        },
        {
            key: 'resources',
            label: 'Resources',
            route: 'q-project-resource-allocations-path'
        },
        {
            key: 'expenses',
            label: 'Expenses',
            route: 'q-project-expense-allocations-path'
        },
        {
            key: 'capex',
            label: 'Capex',
            route: 'q-project-capex-path'
        },
        {
            key: 'pnl',
            label: 'P&L',
            route: 'q-project-pnl-path'
        },

    ])

</script>
<template>
    <div>
        <ul class="nav nav-pills">

            <li v-for="p in pages"
                :key="p.key"
                class="nav-item"
                :class="{ active2: ActivePage === p.key }">

                <router-link class="nav-link"
                             :to="nav(p.route)">
                    {{ p.label }}
                </router-link>

            </li>

        </ul>

        <hr class="mt-0 mb-4" style="border-color:#bbb;" />
    </div>
</template>

<style scoped>
    .nav-pills li a {
        border-radius: 0;
        color: black;
        background-color: transparent;
    }

        .nav-pills li a:hover {
            color: gray;
        }


    .nav-pills li.active2 {
        border-bottom: 3px solid blue;
    }

        .nav-pills li.active2 a {
            color: blue;
        }
</style>